<main class="bg-slate-100 flex flex-col layout-main-container">
    <header class="flex justify-between items-center p-3 border-gray-100 border-b">
        <h2 class="text-2xl font-semibold text-gray-700 mb-1 mx-1.5">
            <span>
                {{'text.import.workflow' | translate}}
            </span>
        </h2>
        <div>
            <i class="ti ti-x text-2xl text-gray-500 hover:bg-gray-100 px-2 py-1.5 rounded-full" (click)="closeModal()"></i>
        </div>
    </header>
    <div class="flex items-center justify-center w-full p-4"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    >
        <label for="dropzone-file" class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
            <div class="flex flex-col items-center justify-center pt-5 pb-6">
                <svg class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                </svg>
                <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">{{'text.click_to_upload' | translate}}</span> {{'text.or_drag_and_drop' | translate}}</p>
                <p class="text-sm text-gray-500 dark:text-gray-400">{{'text.upload_json_file' | translate}}</p>
            </div>
            <input id="dropzone-file" type="file" class="hidden" accept=".json" (change)="onFileSelect($event)" />
        </label>
    </div> 
    <div class="px-4 pb-2" *ngIf="file">
        <p class="text-blue-500">"{{ file.name }}" {{'text.file_ready_to_import' | translate}}</p>
    </div>
    <div class="flex items-center justify-end px-4 py-4 border-t border-gray-200 rounded-b">
        <button  type="button" class="mr-3 text-gray-500 bg-white hover:bg-gray-100 rounded-lg border border-gray-200 text-base font-medium px-4 py-2 hover:text-gray-900" (click)="closeModal()">Cancel</button>
        <button (click)="exportWorkflow()" type="button" class="text-white font-medium rounded-lg text-base px-4 py-2 text-center btn-primary bg-primary">
            <app-spinner [className]="'text-blue-50'" *ngIf="showLoader"></app-spinner>                         
            <i class="ti ti-file-import text-lg mr-1" *ngIf="!showLoader"></i>
            {{'Import' | translate}}
        </button>
    </div>

</main>